<cx-form-required-legend />
<form class="cx-place-order-form form-check" [formGroup]="checkoutSubmitForm">
  <div class="form-group">
    <label>
      <input
        formControlName="termsAndConditions"
        class="scaled-input form-check-input"
        type="checkbox"
        aria-required="true"
        [attr.aria-describedby]="'termsAndConditionsError'"
      />
      <span class="form-check-label">
        {{ 'checkoutReview.confirmThatRead' | cxTranslate }}
        <a
          href="https://www.gea.com/de/assets/261689/"
          class="cx-tc-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ 'checkoutReview.termsAndConditions' | cxTranslate }}
        </a>
        <cx-form-required-asterisks />
        <cx-form-errors
          id="termsAndConditionsError"
          [control]="checkoutSubmitForm.get('termsAndConditions')"
        ></cx-form-errors>
      </span>
    </label>
  </div>

  <button
    (click)="submitForm()"
    class="btn btn-primary btn-block"
    [disabled]="termsAndConditionInvalid"
    [cxAtMessage]="'checkoutReview.orderInProcess' | cxTranslate"
  >
    {{ 'checkoutReview.placeOrder' | cxTranslate }}
  </button>
</form>
